import React, { useRef, useEffect, useState } from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import { makeStyles } from '@material-ui/core/styles'
import { debounce } from 'lodash'

const useStyles = makeStyles((theme) => ({
  root: ({ width }) => ({
    padding: 0,
    borderRadius: 0,
    boxShadow: theme.shadows[1],
    height: width,
    width: '25vw',
  }),
  img: {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    backgroundColor: theme.palette.common.white,
    objectFit: 'contain',
  },
}))

const Picture = ({ className = '', src, alt = '' }) => {
  const rootRef = useRef(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    let resizeObserver = null

    if (rootRef && rootRef.current) {
      resizeObserver = new ResizeObserver(
        debounce(() => {
          return rootRef.current && setWidth(rootRef.current.offsetWidth)
        }, 200),
      )

      resizeObserver.observe(rootRef.current)
    }
    return () => resizeObserver.disconnect()
  }, [rootRef])

  const classes = useStyles({
    width,
  })

  const onImgLoad = (e) => {
    setWidth(e.currentTarget.offsetWidth)
  }

  return (
    <div ref={rootRef} className={`${classes.root} ${className}`}>
      <img className={classes.img} onLoad={onImgLoad} src={src} alt={alt} />
    </div>
  )
}

export default Picture
